const SearchBox = (props) => (
  <input
    type="text"
    name="search"
    placeholder={props.placeholder}
    onChange={props.onChange}
    style={{ padding: "5px" }}
  />
);

export default SearchBox;
